import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'relements/build/esm/ui/avatar';

import { useInitials } from '@src/hooks';
import { Container, Title, EnabledText, EnabledBox } from './styledComponents';

function ToolCard({ url, title, enabled, onClick }) {
  const initials = useInitials(title);

  return (
    <Container data-testid="tool-card" onClick={onClick}>
      <Avatar url={url} initials={initials} />
      <Title
        variant="h3.semi-bold"
        color="black.haptik"
        data-testid="tool-card-title"
      >
        {title}
      </Title>
      {enabled && (
        <EnabledBox data-test-id="tool-card-enabled">
          <EnabledText variant="h5.semi-bold">enabled</EnabledText>
        </EnabledBox>
      )}
    </Container>
  );
}

ToolCard.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  enabled: PropTypes.bool,
  onClick: PropTypes.func,
};

ToolCard.defaultProps = {
  title: 'Give Me Some Title',
  url: '',
  enabled: false,
  onClick: () => {
    /* */
  },
};

export default React.memo(ToolCard);
